import React from 'react';
import { MLabel, MIcon } from 'src/theme';
import { PATH_FINANCE } from 'src/routes/paths';

import HomeIcon from '@material-ui/icons/Home';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '@iconify/react';
import bxHome from '@iconify/icons-bx/bx-home';
import fileInvoice from '@iconify/icons-la/file-invoice';

// ----------------------------------------------------------------------

const path = (name) => `/static/icons/navbar/${name}.svg`;

const ICONS = {
  home: <Icon icon={bxHome} style={{ width: '2em', height: '2em'}}/>,
  invoice: <Icon icon={fileInvoice} style={{ width: '2em', height: '2em'}}/>
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    //subheader: 'general',
    items: [
      {
        title: 'home',
        icon: ICONS.home,
        href: PATH_FINANCE.general.root
      },
      {
        title: 'invoice',
        icon: ICONS.invoice,
        href: PATH_FINANCE.general.invoice
      }
    ]
  }
];

export default navConfig;
